import { ComponentPropsWithoutRef, CSSProperties, forwardRef, memo } from "react";
import { Form, FormikFormProps } from "formik";
import { DisabledContextProvider } from "./DisabledContext";

type MimicFormikFormProps = {
  renderHiddenSubmitButton?: boolean
  disabled?: boolean
  useDisableValueFromParent?: boolean
} & FormikFormProps;

type FormProps = ComponentPropsWithoutRef<"form">;

const hiddenButtonStyle: CSSProperties = {
  width: 0,
  height: 0,
  opacity: 0,
  visibility: "hidden",
};

export const MimicForm = memo<MimicFormikFormProps>(forwardRef<HTMLFormElement, FormProps>(
  ((
    {
      children,
      renderHiddenSubmitButton = true,
      disabled,
      useDisableValueFromParent = false,
      ...props
    }: MimicFormikFormProps, ref) => {
    return (
      <DisabledContextProvider value={disabled} useParentContextValue={useDisableValueFromParent}>
        <Form
          ref={ref}
          {...props}>
          {children}
          {
            /*hidden button for submitting form on ENTER button*/
            !!renderHiddenSubmitButton && <button style={hiddenButtonStyle} type="submit" />
          }
        </Form>
      </DisabledContextProvider>
    );
  }),
));